<template src="./index.html"></template>
<script>
	import {
		getdata
	} from './data.js';
	import {
		findConpanyConfig
	} from '../../../../../../api/Draftgeneration.js';
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				 // tableDataI: getdata().tableDataI,
				delCells: [],
			};
		},
		props: {
			params: {
				type: Object,
				default: {}
			},
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: []
			},
			headobj: {
				type: Object,
				default: {}
			},
			choosecellCode: {
				type: String,
				default: ''
			},
			type: {
				type: String,
				default: ''
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {},
		methods: {
			selectchange(e) {

			},
			headchange() {
				this.$emit('headchange', this.headobj);
			},
			inputblur(e) {
				this.$emit('inputblur', e);
			},
			forhover(table, colum, index) {
				this.$emit('forhover', table, colum, index);
			},
			zcsclick(e) {
				this.$emit('zcsclick', e);
			},
			fordelete(tableData, index) {
				if (this[tableData].length < 3) {
					return false;
				}
				if (this.$notemptyandnull(this.tableDataI[index]['xfs_6_x_1'].id)) {
					this.delCells.push(JSON.parse(JSON.stringify(this.tableDataI[index])));
				}
				this[tableData].splice(index, 1);
				this.$emit('delCellsCode', this.delCells, 'IIIIIIIIIHead');
			},
			foraddhang(tableData, index) {
				let hanh = this.tableDataI.length 
				this.tableDataI.splice(this.tableDataI.length, 0, {
					hanh: hanh,
					"xfs_6_x_1": {
						cellCode: "xfs_6_" + hanh + "_1",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},

					"xfs_6_x_2": {
						cellCode: "xfs_6_" + hanh + "_2",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},

					"xfs_6_x_3": {
						cellCode: "xfs_6_" + hanh + "_3",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_6_x_4": {
						cellCode: "xfs_6_" + hanh + "_4",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_6_x_5": {
						cellCode: "xfs_6_" + hanh + "_5",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_6_x_6": {
						cellCode: "xfs_6_" + hanh + "_6",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_6_x_7": {
						cellCode: "xfs_6_" + hanh + "_7",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_6_x_8": {
						cellCode: "xfs_6_" + hanh + "_8",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_6_x_9": {
						cellCode: "xfs_6_" + hanh + "_9",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
					"xfs_6_x_10": {
						cellCode: "xfs_6_" + hanh + "_10",
						cellType: "0",
						cellVal: "",
						updateDesc: '',
						map: {}
					},
				})
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>